export default class RequestTimeoutError extends Error {
  constructor(timeout: number) {
    super(`Request exceeded after ${timeout}ms`)
    this.name = 'RequestTimeoutError'
  }
}
